export enum InboxArea {
  personal = 'personal',
  general = 'general',
  payment = 'payment-locator',
  tagging = 'tagging',
  project = 'project',
  accountView = 'accountView',
  organization = 'organization'
}

export enum InboxAreaGeneric {
  tagging = 'tagging',
  general = 'general',
  accountView = 'accountView',
  organization = 'organization',
  personal = 'personal',
  organizationEscalated = 'organizationEscalated'
}

export enum InboxTab {
  live = 'live',
  pending = 'pending',
  archive = 'archive',
  escalated = 'escalated',
  organizationEscalated = 'organizationEscalated',
  todo = 'todo',
  done = 'done',
  open = 'open',
  suspected = 'suspected',
  tasks = 'tasks'
}
